import React, { Component } from "react";

import StoryList from "../case-study/list";
import BlogList from "../blog/list";
import ReportList from "../report/list";
import CategoryNavigation from "./category-nav";
import Section from "../section/section";

/**
 * Renders the post content, i.e. the category navigation and cards.
 */
class PostContent extends Component 
{
    list = (type, props) => {
        switch (type) {
            case "blog":
                return (
                    <BlogList 
                        posts={ props.postsData }
                        featuredPosts={ props.featuredPosts }
                        services = { props.servicesData }
                        activeSlug = { props.active }
                        currentPage={ props.currentPage }
                    />
                );
            case "case-study":
                return (
                    <StoryList 
                        stories={ props.postsData }
                        services = { props.servicesData }
                    />
                );
            case "report":
                return (
                    <ReportList 
                        reports={ props.postsData }
                        services = { props.servicesData }
                    />
                );
            default :
                return null;
        }
    }
    
    render () {

        const categories = this.props.categoriesData;

        return (
            <div>
                { this.props.showCategories !== null && 
                    typeof this.props.showCategories !== "undefined" && 
                    this.props.showCategories && this.props.type !== "blog" &&
                    
                    <CategoryNavigation
                        type = { this.props.type }
                        contentButtonData={ categories }
                        active={ this.props.active }
                    />
                }
                { this.props.postsData && typeof this.props.postsData !== "undefined" && this.props.postsData.length > 0 ?
                    <section className={`post-row ${this.props.extraClass}`}>
                        <div className="post-row-cards">
                            { this.list(this.props.type, this.props) }
                        </div>
                    </section>
                :
                    <Section
                        heading="ooops" 
                        content="<p>Looks like there aren't any posts yet.</p>"
                        reversed={ false }
                        className="content-section-narrow"
                    />
                }
            </div>
        );
    }
}

export default PostContent;